import { interceptor } from "./interceptor";
import axios from "axios";

export const ax = axios.create({
    // baseURL: "https://dilipsindiaapi.stellifyflows.in",
    baseURL: "https://loyalityapi.dilipsindia.com",
});

interceptor(ax);